<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Admission Details</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">Admission</a></span>
                                        </div>
                                        <span>Admission Details</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <!-- faq area start here  -->
        <section class="bd-faq-area pt-120 pb-95">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="bd-section-title-wrapper text-center mb-55 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <h2 class="bd-section-title mb-0">Embark on Your <br />Educational Journey</h2>
                            <p>Unlock your Child’s Potentials - Enroll Now</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-6 col-lg-6">
                        <div class="bd-faq-content bd-faq-content-4 mb-25 wow fadeInLeft" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-faq">
                                <div class="accordion" id="accordionExample">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingOne">
                                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne" aria-expanded="true"
                                                aria-controls="collapseOne">
                                                For Non-RTE Students
                                            </button>
                                        </h2>
                                        <div id="collapseOne" class="accordion-collapse collapse show"
                                            aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                <ul>
                                                    <li>
                                                        <strong>Admission Team: </strong>A dedicated counselling team
                                                        will assist
                                                        students in selecting the appropriate class.
                                                    </li>
                                                    <li>
                                                        <strong>Fill Application Form: </strong>Students can complete
                                                        the
                                                        application process either through the printed forms available
                                                        or by
                                                        utilizing the online admission portal of the Board.
                                                    </li>
                                                    <li>
                                                        <strong>Document Verifications: </strong>A mandatory visit to
                                                        the school is
                                                        required for physical document verification. Students are
                                                        expected to
                                                        furnish their authentic Birth Certificate, Transfer Certificate
                                                        (TC), and
                                                        Aadhaar Card during this process.
                                                    </li>
                                                    <li>
                                                        <strong>Fees Payment: </strong>Students have the option to make
                                                        payments
                                                        through a QR code scan or a Bank Challan. A fee receipt (Bank
                                                        Challan) will
                                                        be generated and handed over to the students/parents, which can
                                                        be used for
                                                        direct deposit of fees into the relevant bank accounts. Students
                                                        must
                                                        deposit the fee in the bank and submit the admission form along
                                                        with the
                                                        bank-deposited challan copy for confirmation of admission.
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingThree">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                aria-expanded="false" aria-controls="collapseThree">
                                                For Right to Education (RTE) Students
                                            </button>
                                        </h2>
                                        <div id="collapseThree" class="accordion-collapse collapse"
                                            aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                <ul>
                                                    <li>Students will enrol on the RTE Portal, and a list of selected
                                                        students
                                                        will be
                                                        provided by the RTE Department to the respective school.</li>
                                                    <li>Respective schools will initiate the admission process and
                                                        update the
                                                        information on the RTE portal.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6">
                        <div class="bd-faq-thumb-wrapper mb-70">
                            <div class="bd-faq-thumb">
                                <div class="p-relative wow fadeInRight" data-wow-duration="1s" data-wow-delay=".3s">
                                    <img src="/img/home/faqs.png" alt="Image not found"
                                        style="border-radius: 10px;">
                                    <div class="panel-2 wow"></div>
                                </div>
                            </div>
                            <div class="bd-faq-shape d-none d-lg-block">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- faq area end here  -->

        <!-- faq area 2 start here  -->
        <section class="bd-faq-area-2 theme-bg-6 pt-120 pb-70">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="bd-section-title-wrapper text-center mb-35 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <h2 class="bd-section-title mb-0">Additional Details</h2>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <h3>Admission Guidelines</h3>
                        <div class="bd-faq-2 mb-50 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <ul>
                                <li>
                                    <div class="bd-faq-number"><span>01</span></div>
                                    <div class="bd-faq-content-3">
                                        <p>Admissions for the academic session of the school commence in the first week
                                            of
                                            April each year.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="bd-faq-2 mb-50 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <ul>
                                <li>
                                    <div class="bd-faq-number"><span>02</span></div>
                                    <div class="bd-faq-content-3">
                                        <p>Candidate registration should be completed before seeking admission.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="bd-faq-2 mb-50 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <ul>
                                <li>
                                    <div class="bd-faq-number"><span>03</span></div>
                                    <div class="bd-faq-content-3">
                                        <p>The child will undergo an interview and/or an admission test.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="bd-faq-2 mb-50 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <ul>
                                <li>
                                    <div class="bd-faq-number"><span>04</span></div>
                                    <div class="bd-faq-content-3">
                                        <p>It is mandatory to provide their authentic Birth Certificate, Transfer
                                            Certificate
                                            (TC), and Aadhaar Card during the admission process.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="bd-faq-2 mb-50 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <ul>
                                <li>
                                    <div class="bd-faq-number"><span>05</span></div>
                                    <div class="bd-faq-content-3">
                                        <p>Incomplete forms will not be accepted.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="bd-faq-2 mb-50 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <ul>
                                <li>
                                    <div class="bd-faq-number"><span>06</span></div>
                                    <div class="bd-faq-content-3">
                                        <p>The head of the institute reserves the right to admit or reject a candidate
                                            without
                                            providing any reason.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="bd-faq-2 mb-50 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <ul>
                                <li>
                                    <div class="bd-faq-number"><span>07</span></div>
                                    <div class="bd-faq-content-3">
                                        <p>Parents are kindly requested to pay the fee as per the specified schedule,
                                            failing
                                            which their child's enrolment may be withdrawn.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <h3>Examination & Promotion</h3>
                        <div class="bd-faq-2 mb-50 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".3s">
                            <ul>
                                <li>
                                    <div class="bd-faq-number"><span>01</span></div>
                                    <div class="bd-faq-content-3">
                                        <p>Students are continuously evaluated in accordance with the guidelines issued
                                            by
                                            RBSE.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="bd-faq-2 mb-50 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".3s">
                            <ul>
                                <li>
                                    <div class="bd-faq-number"><span>02</span></div>
                                    <div class="bd-faq-content-3">
                                        <p>Maintaining a minimum of 75% attendance is compulsory.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="bd-faq-2 mb-50 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".3s">
                            <ul>
                                <li>
                                    <div class="bd-faq-number"><span>03</span></div>
                                    <div class="bd-faq-content-3">
                                        <p>In the case of severe illness, a medical certificate must be submitted by the
                                            parent.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div class="bd-faq-2 mb-50 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".3s">
                            <ul>
                                <li>
                                    <div class="bd-faq-number"><span>04</span></div>
                                    <div class="bd-faq-content-3">
                                        <p>Students who are absent from any subject's examination will not be
                                            re-examined and
                                            will not be eligible for any promotion.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="bd-faq-2 mb-50 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".3s">
                            <ul>
                                <li>
                                    <div class="bd-faq-number"><span>05</span></div>
                                    <div class="bd-faq-content-3">
                                        <p>Answer sheets for the final examination will not be disclosed.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="bd-faq-2 mb-50 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".3s">
                            <ul>
                                <li>
                                    <div class="bd-faq-number"><span>06</span></div>
                                    <div class="bd-faq-content-3">
                                        <p>The results declared at the end of the academic year are final, and no
                                            requests for
                                            re-examination will be entertained.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- faq area 2 end here  -->

        <!-- joining area start here  -->
        <section style="display: none;">
            <div>
                <div class="bd-joining-area fix pt-100 pb-95 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
                    <!-- joiniong bg -->
                    <div class="bd-joining-bg" data-background="/img/home/bg_1.png"></div>
                    <!-- joining bg overlay -->
                    <div class="bd-joining-bg-overlay"></div>
                    <div class="bd-joining">
                        <div class="bd-joining-shape-wrapper d-none d-md-block">
                            <div class="bd-joining-shape-1 p-absolute">

                            </div>
                            <div class="bd-joining-shape-2 p-absolute">

                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-8">
                                <div class="bd-joining-content text-center">
                                    <div class="bd-section-title-wrapper is-white mb-45 wow fadeInUp"
                                        data-wow-duration="1s" data-wow-delay=".3s">
                                        <h2 class="bd-section-title mb-0">Join Our New Session</h2>
                                        <p>Vedanta Gurukul Public School, believes that good questions drive good
                                            answers.
                                            Whether it's a query about the world or a challenge.</p>
                                    </div>
                                    <div class="bd-joining-btn">
                                        <a href="https://rgs.eshala.co.in/page/enquiry" class="bd-btn btn-white">
                                            <span class="bd-btn-inner">
                                                <span class="bd-btn-normal">Contribute</span>
                                                <span class="bd-btn-hover">Contribute</span>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- bd-joining-bottom-line -->
                    <div class="bd-joining-line"></div>
                    <div class="bd-joining-line-2"></div>
                </div>
            </div>
        </section>
        <!-- joining area end here  -->

    </main>
</template>
<script>
export default {
    name: "AdmissionView",
};
</script>
